import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';
import styles from './styles';
import SessionIcon from '../../../../public/image/session.png';
import { extendSession, logout } from './session.util';

import { getCookie } from '../../../hooks/useCookie';

const Session = () => {
  const graphql = useApolloClient();
  const [showSessionWarning, setShowSessionWarning] = useState(false);
  const [timeLeftInSession, setTimeLeftInSession] = useState(0);
  const theme = useTheme();

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const session = getCookie('session') ? JSON.parse(getCookie('session')) : null;

      if (session != null && session.sessionExpiryTime != null) {
        setTimeLeftInSession(
          Math.trunc((JSON.parse(getCookie('session')).sessionExpiryTime - now) / 1000)
        );

        if (session.sessionExpiryTime - now < 0) {
          logout(setShowSessionWarning);
        } else if (session.sessionExpiryTime - now < 60000) {
          setShowSessionWarning(true);
        }
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [timeLeftInSession, showSessionWarning]);
  return (
    <Dialog
      PaperProps={{ sx: styles(theme).dialogPaper }}
      open={showSessionWarning}
      onClose={() => logout(setShowSessionWarning)}
      maxWidth='xs'
      fullWidth
      disableBackdropClick
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      sx={styles(theme).eirDialogContainer}
    >
      <DialogTitle id='alert-dialog-title' sx={styles(theme).eirDialogTitle}>
        Session Information
      </DialogTitle>

      <DialogContent sx={styles(theme).eirDialogContent}>
        <Box component='img' sx={styles(theme).image} src={SessionIcon.src} alt='alt Text' />

        <DialogContentText id='alert-dialog-description' sx={styles(theme).notification}>
          <Typography>
            Your session will expire in{' '}
            <Typography component='span' fontWeight='bold'>
              {' '}
              {timeLeftInSession} seconds
            </Typography>
          </Typography>

          <Typography>Do you want to keep your session active?</Typography>
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={styles(theme).eirDialogAction}>
        <Grid item xs={12} sm={12} md={12} align='center' sx={styles(theme).eirDialog}>
          <Button
            variant='buttonMedium'
            onClick={() => extendSession({ graphql, setShowSessionWarning })}
            sx={styles(theme).purpleBtn}
            aria-label='Stay logged in'
          >
            Stay logged in
          </Button>
          <Button
            variant='buttonMedium'
            onClick={() => logout(setShowSessionWarning)}
            sx={styles(theme).eirButton}
            color='primary'
            aria-label='Log out'
          >
            Log out
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default Session;
